import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartState } from '@b2b/features/cart/core/store/cart.reducer';

export const CART_FEATURE = 'CART';
export const selectCart = createSelector(createFeatureSelector<CartState>(CART_FEATURE), state => state);
